export default class ConfrontationBenchmarkHelper {
  static sumBy(benchmarkItems: any[], valueFn: (item: any) => number) {
    return benchmarkItems!.reduce((total, item) => total + valueFn(item), 0);
  }

  static aggregateKPIs(kpiItems: any[]) {
    const kpis = kpiItems.reduce(
      (total, item) => {
        const itemKpis = item.kpis;

        return {
          ...total,
          accessPrimeTime: total.accessPrimeTime + itemKpis.accessPrimeTime,
          audienceCount: total.audienceCount + itemKpis.audienceCount,
          dayTime: total.dayTime + itemKpis.dayTime,
          detectionsCount: total.detectionsCount + itemKpis.detectionsCount,
          driveTime: total.driveTime + itemKpis.driveTime,
          grpCount: total.grpCount + Number.parseFloat(itemKpis.grpCount),
          morningTime: total.morningTime + itemKpis.morningTime,
          nightTime: total.nightTime + itemKpis.nightTime,
          primeTime: total.primeTime + itemKpis.primeTime,
          radioAverageBreakLength:
            total.radioAverageBreakLength + itemKpis.radioAverageBreakLength,
          radioAverageBreakPosition:
            total.radioAverageBreakPosition +
            itemKpis.radioAverageBreakPosition,
          radioBreakCompetitor:
            total.radioBreakCompetitor + itemKpis.radioBreakCompetitor,
          radioBreaks: total.radioBreaks + itemKpis.radioBreaks,
          radioDetectionsCount:
            total.radioDetectionsCount + itemKpis.radioDetectionsCount,
          radioPosition: total.radioPosition + itemKpis.radioPosition,
          radioPsu: total.radioPsu + itemKpis.radioPsu,
          radioSecondsCount:
            total.radioSecondsCount + itemKpis.radioSecondsCount,
          radioWeekendsCount:
            total.radioWeekendsCount + itemKpis.radioWeekendsCount,
          secondsCount: total.secondsCount + item.secondsCount,
          tvAverageBreakLength:
            total.tvAverageBreakLength +
            Number.parseFloat(itemKpis.tvAverageBreakLength),
          tvAverageBreakPosition:
            total.tvAverageBreakPosition +
            Number.parseFloat(itemKpis.tvAverageBreakPosition),
          tvBreakCompetitor:
            total.tvBreakCompetitor + itemKpis.tvBreakCompetitor,
          tvBreaks: total.tvBreaks + itemKpis.tvBreaks,
          tvDetectionsCount:
            total.tvDetectionsCount + itemKpis.tvDetectionsCount,
          tvPosition: total.tvPosition + itemKpis.tvPosition,
          tvPsu: total.tvPsu + itemKpis.tvPsu,
          tvSecondsCount: total.tvSecondsCount + itemKpis.tvSecondsCount,
          tvWeekendsCount: total.tvWeekendsCount + itemKpis.tvWeekendsCount,
        };
      },
      {
        accessPrimeTime: 0,
        audienceCount: 0,
        dayTime: 0,
        detectionsCount: 0,
        driveTime: 0,
        grpCount: 0,
        id: "-1_Company",
        morningTime: 0,
        nightTime: 0,
        primeTime: 0,
        radioAverageBreakLength: 0,
        radioAverageBreakPosition: 0,
        radioBreakCompetitor: 0,
        radioBreaks: 0,
        radioDetectionsCount: 0,
        radioPosition: 0,
        radioPsu: 0,
        radioSecondsCount: 0,
        radioWeekendsCount: 0,
        secondsCount: 0,
        tvAverageBreakLength: 0,
        tvAverageBreakPosition: 0,
        tvBreakCompetitor: 0,
        tvBreaks: 0,
        tvDetectionsCount: 0,
        tvPosition: 0,
        tvPsu: 0,
        tvSecondsCount: 0,
        tvWeekendsCount: 0,
      }
    );

    return {
      id: "-1",
      name: "BENCHMARK",
      iconUrl: null,
      kpis: {
        ...kpis,
        grpCount: kpis.grpCount + "",
        tvAverageBreakLength: kpis.tvAverageBreakLength + "",
        tvAverageBreakPosition: kpis.tvAverageBreakPosition + "",
      },
    };
  }
}
